// features/numeracyLiteracy/numeracyLiteracySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  NumeracyData: {
    NumeracyData: [], // <-- This is the array you're trying to `.find()` or `.findIndex()` on
  },
  source: "",
};


const numeracyLiteracySlice = createSlice({
  name: "numeracyLiteracy",
  initialState,
  reducers: {
    setNumeracyData(state, action) {
      state.NumeracyData = action.payload;
    },

updateSource(state, action) {
  state.source = action.payload;

  // Fix: Access nested NumeracyData array
  if (Array.isArray(state.NumeracyData?.NumeracyData)) {
    state.NumeracyData.NumeracyData = state.NumeracyData.NumeracyData.map(item => ({
      ...item,
      source: action.payload,
    }));
  }
}
,
updateEntry(state, action) {
  const {
    districtId,
    locationId,
    field,
    value,
    provinceId,
    censusYear,
  } = action.payload;

  const numericValue = Number(value) || 0;

  const dataArray = state.NumeracyData.NumeracyData;
  const index = dataArray.findIndex(
    item =>
      item.District_Id === districtId &&
      item.Location_Id === locationId
  );

  if (index > -1) {
    const existing = dataArray[index];

    const newMale = field === "Male" ? numericValue : Number(existing.Male || 0);
    const newFemale = field === "Female" ? numericValue : Number(existing.Female || 0);

    dataArray[index] = {
      ...existing,
      [field]: numericValue,
      Total: newMale + newFemale,
      Province_Id: provinceId,
      Census_Year: censusYear,
    };
  } else {
    const isMale = field === "Male";
    const male = isMale ? numericValue : 0;
    const female = !isMale ? numericValue : 0;

    dataArray.push({
      District_Id: districtId,
      Location_Id: locationId,
      Male: male,
      Female: female,
      Total: male + female,
      Type: "Functional",
      source: state.source || "Unknown",
      Province_Id: provinceId,
      Census_Year: censusYear,
    });
  }
}
,

    resetNumeracyData(state) {
      state.NumeracyData = [];
      state.source = "";
    },
  },
});

export const {
  setNumeracyData,
  updateEntry,
  updateSource,
  resetNumeracyData,
} = numeracyLiteracySlice.actions;

export default numeracyLiteracySlice.reducer;
